export default __webpack_public_path__ + "6f5f91074db0a67e376fcb39a6d109fb.svg";